module.exports = __webpack_public_path__ + "static/media/OZ.9e5d1bed.png";